<template lang="pug">
.outer-wrapper(id="AdvancedMenu-wrapper")
  .float-left.version v{{ version }}
  .container-wrapper
    .column(id="AdvancedMenu-extensionsColumn", v-if='userIsAdmin')
      .column-header
        font-awesome-icon.column-icon(icon="film")
        span.column-title {{$t('Extensions management')}}
      .column-content
        p
          el-button(id="AdvancedMenu-addExtensionButton" @click='openComponent("AddExtensionForm")', size="mini", type="text")
            span {{$t('Add/upgrade extension')}} &nbsp;
        p
          el-button(id="AdvancedMenu-deleteUnusedExtensionsButton" @click='openComponent("DeleteExtensionsForm")', size="mini", type="text")
            span {{$t('Unused Extensions')}} &nbsp;
        p
          el-button(id="AdvancedMenu-deleteUnusedExtensionsButton" @click='openComponent("ExtensionsUsageReport")', size="mini", type="text")
            span {{$t('Used Extensions')}} &nbsp;
    .column(id="AdvancedMenu-mediaColumn", v-if='userIsAdmin')
      .column-header
        font-awesome-icon.column-icon(icon="film")
        span.column-title {{$t('Media management')}}
      .column-content
        p
          el-button(id="AdvancedMenu-showMediaExceptionsButton" @click='openComponent("MediaExceptions")', size="mini", type="text")
            span {{$t('Show all media Exceptions')}} &nbsp;
        p
          el-button(id="AdvancedMenu-showFilesInQueueButton" @click='openComponent("FilesInQueue")', size="mini", type="text")
            span {{$t('Show file conversion queue')}} &nbsp;
        p
          el-button(id="AdvancedMenu-createContentEdition" @click='openComponent("CreateContentEdition")', size="mini", type="text")
            span {{$t('Create new content edition')}} &nbsp;
        p
          el-button(id="AdvancedMenu-createContentEdition" @click='openComponent("MassRenameLocalContent")', size="mini", type="text")
            span {{$t('Rename local content')}} &nbsp;
        p
          el-button(id="AdvancedMenu-holidaySetsButton" @click='openComponent("Holidaysets")', size="mini", type="text")
            span {{$t('Play period sets')}}
        p
          el-button(id="AdvancedMenu-tagManagerButton" @click='openComponent("TagManager")', size="mini", type="text")
            span {{$t('Tag Manager')}}
    .column(id="AdvancedMenu-reportsColumn")
      .column-header
        font-awesome-icon.column-icon(icon="film")
        span.column-title {{$t('Reports')}}
      .column-content
        p
          el-button(id="AdvancedMenu-ledReportButton" @click='openComponent("LedReport")', size="mini", type="text")
            span {{$t('Led Report')}} &nbsp;
        p
          el-button(id="AdvancedMenu-deviceReport" @click='openComponent("DeviceReport")', size="mini", type="text")
            span {{$t('Device Report')}} &nbsp;
        p
          el-button(id="AdvancedMenu-failedRequests" @click='openComponent("FailedRequests")', size="mini", type="text")
            span {{$t('Failed Requests')}} &nbsp;
    .column(id="AdvancedMenu-deviceManagementColumn", v-if='userIsAdmin')
      .column-header
        font-awesome-icon.column-icon(icon="desktop")
        span.column-title {{$t('Device management')}}
      .column-content
        p
          el-button(id="AdvancedMenu-addDeviceButton" @click='openComponent("AddEditDevice")', size="mini", type="text")
            span {{$t('Add device')}} &nbsp;
        p
          el-button(id="AdvancedMenu-addMassDeviceButton" @click='openComponent("AddMassDevice")', size="mini", type="text")
            span {{$t('Add series of devices')}} &nbsp;
        p
          el-button(id="AdvancedMenu-AddFromCSV" @click='openComponent("AddFromCSV")', size="mini", type="text")
            span {{$t('Add devices from CSV')}} &nbsp;
        p
          el-button(id="AdvancedMenu-searchByUUID" @click='openComponent("SearchByUUID")', size="mini", type="text")
            span {{$t('Manage by UUID')}} &nbsp;
        p
          el-button(id="AdvancedMenu-unknownUUIDs" @click='openComponent("UnknownUUIDs")', size="mini", type="text")
            span {{$t('Unknown UUIDs')}} &nbsp;
        //- p
        //-   el-button(id="AdvancedMenu-massRequest" @click='openComponent("SendMassReqest")', size="mini", type="text")
        //-     span {{$t('Send Mass Request')}} &nbsp;
    .column(id="AdvancedMenu-organizationColumn", v-if='userIsAdmin')
      .column-header
        font-awesome-icon.column-icon(icon="bars")
        span.column-title {{$t('Organization')}}
      .column-content
        p
          el-button(id="AdvancedMenu-clientsButton" @click='openComponent("Clients")', size="mini", type="text")
            span {{$t('Clients')}}
        p
          el-button(id="AdvancedMenu-networksButton" @click='openComponent("Networks")', size="mini", type="text")
            span {{$t('Networks')}}
    .column(id="AdvancedMenu-accessControlColumn", v-if='userIsAdmin')
      .column-header
        font-awesome-icon.column-icon(icon="user-secret")
        span.column-title {{$t('Access control')}}
      .column-content
        p
          el-button(id="AdvancedMenu-usersButton" @click='openComponent("Users")', size="mini", type="text")
            span {{$t('Users')}}
        p
          el-button(id="AdvancedMenu-rolesButton" @click='openComponent("Roles")', size="mini", type="text")
            span {{$t('Roles')}}
        p
          el-button(id="AdvancedMenu-privilegesButton" @click='openComponent("Privileges")', size="mini", type="text")
            span {{$t('Privileges')}}
  el-dialog(fullscreen, :close-on-click-modal="false", title='', :visible.sync='dialogVisible', @close='dialogVisible = false; dialogComponent = undefined')
    component(
      v-if='dialogComponent && dialogVisible',
      v-bind:is='dialogComponent',
      @changeNetwork='changeNetwork'
    )
</template>

<script>
import AddEditDevice from './Device/AddEditDevice'
import LedReport from './Device/LedReport'
import AddMassDevice from './Device/AddMassDevice'
import SearchByUUID from './Device/SearchByUUID'
import UnknownUUIDs from './Device/UnknownUUIDs'
import FailedRequests from './Device/FailedRequests'
// import SendMassRequest from './Device/SendMassRequest'
import AddExtensionForm from './Medium/AddExtensionForm'
import DeleteExtensionsForm from './Medium/DeleteExtensionsForm'
import ExtensionsUsageReport from './Medium/ExtensionsUsageReport'
import CreateContentEdition from './Medium/CreateContentEdition'
import MassRenameLocalContent from './Medium/MassRenameLocalContent'
import MediaExceptions from './Medium/MediaExceptions'
import FilesInQueue from './File/FilesInQueue'
import Users from './User/List'
import Networks from './Network/List'
import Clients from './Client/List'
import Holidaysets from './Holidayset/List'
import Roles from './Role/List'
import Privileges from './Privilege/List'
import DeviceReport from './Device/DeviceReport'
import AddFromCSV from './Device/AddFromCSV'
import TagManager from './Common/TagManager'

export default {
  props: [],
  components: {
    AddEditDevice,
    AddMassDevice,
    AddExtensionForm,
    DeleteExtensionsForm,
    ExtensionsUsageReport,
    SearchByUUID,
    UnknownUUIDs,
    FailedRequests,
    // SendMassRequest,
    Users,
    Networks,
    Clients,
    Holidaysets,
    Roles,
    Privileges,
    LedReport,
    FilesInQueue,
    DeviceReport,
    CreateContentEdition,
    MassRenameLocalContent,
    AddFromCSV,
    MediaExceptions,
    TagManager
  },
  async created () {
    this.version = await this.$store.dispatch('User/getPackageVersion')
  },
  watch: {
    mediumId: function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: {
      },
      version: '',
      dialogComponent: undefined,
      dialogVisible: false
    }
  },
  methods: {
    reloadLeftComponent () {
      this.$emit('reloadLeftComponent')
    },
    changeNetwork (networkId) {
      this.$emit('changeNetwork', networkId)
      this.dialogVisible = false
      this.dialogComponent = undefined
    },
    // FIXME DRY
    openComponent (component) {
      this.dialogComponent = component
      this.dialogVisible = true
    },
    goHome () {
      this.pushRoute('Library', 'devices')
    },
    closeAddDevice () {
      this.addDeviceVisible = false
    }
  },
  computed: {
    currentUserNetworks () {
      return this.$store.state.User.user.Networks || []
    },
    currentUserNetworkId: {
      get () {
        return this.$store.state.User.user.lastNetworkId || null
      },
      async set (newNetworkId) {
        await this.$store.dispatch('User/changeNetwork', newNetworkId)
        this.$nextTick(function () {
          // this.$router.push({ path: '/layout/Library/devices/medium,0' })
          this.pushRoute('Library', 'devices', 'medium,0')
        })
      }
    },
    // FIXME DRY
    userRoleNames () {
      return this.$store.state.User.user.Roles.map(role => role.name)
    },
    userIsAdmin () {
      return this.userRoleNames.includes('superadministrator') || this.userRoleNames.includes('administrator')
    },
    userIsSuperAdmin () {
      return this.userRoleNames.includes('superadministrator')
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../../theme-m4b/src/common/var.scss";
.outer-wrapper {
  border-bottom: 1px solid $--border-color-lighter;
  margin-bottom: 40px;
}
.container-wrapper  {
  display: flex;
  justify-content: flex-end;
}
.column {
  border-right: 1px solid $--border-color-lighter;
  min-height: 100px;
  margin: 16px 0px 16px 0px;
  padding: 10px 40px 10px 40px;
  .flex-inline {
    display: flex;
  }
  &.clients {
    border-right: 0px solid $--border-color-lighter;
  }
  .column-icon {
    color: $--color-primary;
    font-size: 20px;
  }
  .column-header {
    .column-title {
      padding-left: 20px;
      color:$--color-black;
      font-size: 14px;
    }
    .home-icon {
      color: $--color-primary;
      font-size: 40px;
      margin-top: -20px;
    }
  }
  .column-content {
    margin-top: 30px;
    margin-left: 40px;
    color: $--color-text-secondary;
    button {
      color: $--color-text-secondary;
    }
  }
  .logout-button {
    margin-left: -27px;
    margin-top: 10px;
    border: 1px solid $--color-primary;
    width: 150px;
  }
  .lang-button {
    &.active {
      background-color: $--color-success;
      color: $--color-black;
    }
  }
}
.version {
  margin-left: 24px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdvancedMenu.vue